import { dealsFilterStore } from 'components/Filters/FilterStore'
import FilterModal, {
  FilterGroup,
} from 'components/Filters/components/FilterModal'
import { DateRangeFilter } from 'components/Filters/fields/DateRangeFilter'
import {
  ContactCountRangeFilter,
  DaysSinceLastUpdateRangeFilter,
  NoteCountRangeFilter,
  RangeFilter,
} from 'components/Filters/fields/RangeFilter'
import { SelectFilter } from 'components/Filters/fields/SelectFilter'
import apiService from 'services/api'
import { useCategorySubcategoryOptions } from 'hooks/useCategorySubcategoryFilterOptions'

export default function DealsTableFilters() {
  const api = apiService()
  const { data: userOptions } = api.useGetUserOptions(true)
  const { data: stageOptions } = api.useGetSalesStageOptions(true)
  const { data: tagsOptions } = api.useGetTagsOptions(true)
  const { data: productsOptions } = api.useGetProductsOptions()
  const { data: distributorOptions } =
    api.useGetCompanyDistributorsOptions(true)
  const { data: contactTagsOptions } = api.useGetTagsOptions(true, 'contacts')

  const { categoriesOptions, subCategoriesOptions } =
    useCategorySubcategoryOptions({
      filterStore: dealsFilterStore,
    })

  return (
    <FilterModal store={dealsFilterStore} identifier="DEALS_TABLE">
      <FilterGroup title={'Opportunity Details'}>
        <RangeFilter
          title="Size"
          filterKey="company_size"
          store={dealsFilterStore}
        />
        <SelectFilter
          title="Category"
          filterKey={'category'}
          filterStore={dealsFilterStore}
          options={categoriesOptions}
        />
        <SelectFilter
          title="Type"
          filterKey={'sub_category'}
          filterStore={dealsFilterStore}
          options={subCategoriesOptions}
        />
      </FilterGroup>
      <FilterGroup title="Account">
        <SelectFilter
          filterKey="product"
          title="Products"
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          options={productsOptions as any}
          filterStore={dealsFilterStore}
        />
        <SelectFilter
          filterKey="sales_stage"
          title="Sales Stage"
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          options={stageOptions as any}
          filterStore={dealsFilterStore}
        />
        <SelectFilter
          filterKey="account_owner"
          title="Account Owner"
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          options={userOptions as any}
          filterStore={dealsFilterStore}
        />
        <SelectFilter
          filterKey="tags"
          title="Tags"
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          options={tagsOptions as any}
          filterStore={dealsFilterStore}
        />
        <SelectFilter
          filterKey="contact_tags"
          title="Contact Labels"
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          options={contactTagsOptions as any}
          filterStore={dealsFilterStore}
        />
        <SelectFilter
          filterKey="distributors"
          title="Known Distributors"
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          options={distributorOptions as any}
          filterStore={dealsFilterStore}
        />
        <NoteCountRangeFilter store={dealsFilterStore} />
        <ContactCountRangeFilter store={dealsFilterStore} />
      </FilterGroup>
      <FilterGroup title="Predicted Values">
        <RangeFilter
          filterKey="predicted_volume"
          decimalScale={1}
          store={dealsFilterStore}
          title="Predicted Volume"
        />
        <RangeFilter
          title="Predicted Revenue"
          filterKey="predicted_revenue"
          store={dealsFilterStore}
        />
        <DateRangeFilter
          title="Estimated Close Date"
          filterKey="estimated_close_date"
          filterStore={dealsFilterStore}
        />
      </FilterGroup>
      <FilterGroup title="Overrides">
        <RangeFilter
          title="Monthly Volume (override)"
          filterKey="monthly_volume_override"
          decimalScale={1}
          store={dealsFilterStore}
        />
        <RangeFilter
          title="Monthly Revenue (override)"
          filterKey="monthly_revenue_override"
          store={dealsFilterStore}
        />
        <DateRangeFilter
          title="Close Date (override)"
          filterKey="close_date_override"
          filterStore={dealsFilterStore}
        />
      </FilterGroup>
      <FilterGroup title="User Activity">
        <DateRangeFilter
          title="Last Modified"
          filterKey="modified"
          filterStore={dealsFilterStore}
        />
        <DateRangeFilter
          title="Date Created"
          filterKey="created"
          filterStore={dealsFilterStore}
        />
        <RangeFilter
          filterKey="time_in_stage"
          decimalScale={1}
          store={dealsFilterStore}
          title="Days In Stage"
          minAllowNegative={false}
          maxAllowNegative={false}
        />
        <DaysSinceLastUpdateRangeFilter store={dealsFilterStore} />
      </FilterGroup>
    </FilterModal>
  )
}
